"use strict";

var _SpaAnalyticsHead, _AppHeaderDesktop, _AppHeaderMobile, _AsyncBoundary, _AuthProvider;
import { SpaAnalyticsHead } from '@autoguru/analytics';
import { AuthProvider, createClient, withRequiredAuthentication } from '@autoguru/auth';
import { getToken } from '@autoguru/auth/relay';
import { PageLoading } from '@autoguru/components';
import { pageAsidePortalId } from '@autoguru/expand-side-nav';
import { Portal, StickyBox, useResponsiveValue } from '@autoguru/overdrive';
import { EnvironmentProvider, createEnvironment } from '@autoguru/relay';
import { GlobalSupplierProvider } from '@autoguru/supplier-provider';
import { AsyncBoundary } from '@autoguru/suspense';
import { useMemo } from 'react';
import { AppAside } from '../features/app-aside';
import { AppHeaderDesktop, AppHeaderMobile, pageHeaderPortalId } from '../features/app-header';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const relayModernEnvironment = createEnvironment({
  fetcherOptions: {
    getToken
  }
});
const authClient = createClient();
const AuthRequiredApp = withRequiredAuthentication(() => {
  const isDesktop = useResponsiveValue([false, true]);
  return useMemo(() => /*#__PURE__*/_jsx(EnvironmentProvider, {
    environment: relayModernEnvironment,
    children: /*#__PURE__*/_jsxs(GlobalSupplierProvider, {
      children: [process.env.NODE_ENV !== "production" ? null : _SpaAnalyticsHead || (_SpaAnalyticsHead = /*#__PURE__*/_jsx(SpaAnalyticsHead, {})), /*#__PURE__*/_jsx(Portal, {
        container: document.querySelector(`#${pageHeaderPortalId}`),
        children: /*#__PURE__*/_jsx(AsyncBoundary, {
          fallback: PageLoading,
          children: /*#__PURE__*/_jsx(StickyBox, {
            top: "none",
            zIndex: 1,
            children: isDesktop ? _AppHeaderDesktop || (_AppHeaderDesktop = /*#__PURE__*/_jsx(AppHeaderDesktop, {})) : _AppHeaderMobile || (_AppHeaderMobile = /*#__PURE__*/_jsx(AppHeaderMobile, {}))
          })
        })
      }), /*#__PURE__*/_jsx(Portal, {
        noThemedWrapper: true,
        container: document.querySelector(`#${pageAsidePortalId}`),
        children: _AsyncBoundary || (_AsyncBoundary = /*#__PURE__*/_jsx(AsyncBoundary, {
          fallback: PageLoading,
          children: /*#__PURE__*/_jsx(AppAside, {})
        }))
      })]
    })
  }), [isDesktop]);
});
export const App = () => _AuthProvider || (_AuthProvider = /*#__PURE__*/_jsx(AuthProvider, {
  allow_socials: false,
  client: authClient,
  children: /*#__PURE__*/_jsx(AuthRequiredApp, {})
}));